import { useContext, useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import { useTranslation } from "react-i18next";
import OverlayMenuBase from "modals/base/OverlayMenuBase";
import { medusaRequester, requester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { rpad2D } from "shared/utils/Utils";
import FlexChild from "layouts/flex/FlexChild";
import style from "./SideMenu.module.css";
import P from "components/P";
import allProductImg from "resources/img/icons/전제상품.svg";
import allProductTransImg from "resources/img/icons/전제상품_흰색.png";
import mouth from "resources/img/icons/입호흡.svg";
import mouthTrans from "resources/img/icons/입호흡_흰색.png";
import breath from "resources/img/icons/폐호흡.svg";
import breathTrans from "resources/img/icons/폐호흡_흰색.png";
import device from "resources/img/icons/기계.svg";
import deviceTrans from "resources/img/icons/기계_흰색.png";
import etc from "resources/img/icons/코일 및 기타용품.svg";
import etcTrans from "resources/img/icons/코일-및-기타용품_흰색.png";
import dataImg from "resources/img/icons/자료실.svg";
import dataImgTrans from "resources/img/icons/자료실_흰색.png";
import eventImg from "resources/img/circleChecked.png";
import Center from "layouts/wrapper/Center";
import CustomIcon from "components/icons/CustomIcon";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "providers/AuthProvider";

const SideMenu = NiceModal.create((props, ref) => {
    const { userName } = props;
    const modal = useRef();
    const { t } = useTranslation();
    const [withHeader, withFooter] = [true, false];
    const [width, height] = ["80%", "100%"];
    const withCloseButton = false;
    const clickOutsideToClose = true;
    const title = "카테고리";
    const navigate = useNavigate();
    const [categories, setCategories] = useState();

    const onLoginClick = () => {
        NiceModal.show("memberSignIn");
    }
    const onSignUpClick = () => {
        NiceModal.show("memberSignTabModal");
    }

    useEffect(() => {
        let data = "";
        medusaRequester.getAllCategories(data, (result) => {
            setCategories(result.product_categories)
            
        })
    }, [])

    const categoryImages = [
        { img: allProductImg, hoverImg: allProductTransImg },
        { img: mouth, hoverImg: mouthTrans },
        { img: breath, hoverImg: breathTrans },
        { img: device, hoverImg: deviceTrans },
        { img: etc, hoverImg: etcTrans },
        { img: dataImg, hoverImg: dataImgTrans },
    ];


    const Item = ({ name, to, img, hoverImg }) => {
        const [hover, setHover] = useState(false);
        let onMouseEnter = () => setHover(true);
        let onMouseLeave = () => setHover(false);

        const onClick = () => {
            navigate(to);
            modal.current.close();
        }

        return (
            <div className={style.item} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>
                <VerticalFlex gap={10}>
                    <FlexChild>
                        {/* <img width={"28%"} src={hover ? hoverImg : img} color={"black"} backgroundColor={"white"} /> */}
                    </FlexChild>
                    <FlexChild justifyContent={"center"}>
                        <P height={42} weight={"bold"}>{name}</P>
                    </FlexChild>
                </VerticalFlex>
            </div>
        )
    }

    return (
        <OverlayMenuBase backgroundColor={"var(--main-color)"} ref={modal} title={title} width={width} height={height} withHeader={withHeader} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose}>
            <VerticalFlex gap={40}>
                <FlexChild>
                    <div className={style.wrap}>
                        <Item name={"전체보기"} img={dataImg} hoverImg={dataImgTrans} to={`productList/category/all`} />
                        <Item name={"이벤트"} img={eventImg} hoverImg={eventImg} to={`productList/category/event`} />
                        {categories && categories.map((category, index) => (
                            <Item
                                key={category.id}
                                name={category.name} // 텍스트
                                to={`productList/category/${category.id}`} // 경로
                                img={categoryImages[index].img} // 고정 이미지
                                hoverImg={categoryImages[index].hoverImg} // 고정 hover 이미지
                            />
                        ))}

                    </div>
                </FlexChild>
                <FlexChild width={"90%"}>
                    {
                        !userName &&
                        <HorizontalFlex alignItems={"flex-start"} gap={10} justifyContent={"flex-start"}>
                            <FlexChild>
                                <div className={style.textButton} onClick={onLoginClick}>
                                    <P weight={700}>로그인</P>
                                </div>
                            </FlexChild>
                            <FlexChild>
                                <div className={style.textButton} onClick={onSignUpClick}>
                                    <P weight={700}>회원가입</P>
                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    }

                </FlexChild>
            </VerticalFlex>
        </OverlayMenuBase>
    );
});

export default SideMenu;
